<template>
  <div class="d-flex flex-column h-100">
    <vue-custom-scrollbar
      class="app-content-padding flex-grow-1 overflow-hidden h-100"
    >
      <ts-page-title
        :title="$t('user.pageTitle')"
        :breadcrumb="[
          { text: $t('home'), href: '/' },
          {
            text: $t('user.pageTitle'),
            href: '/admin/users',
          },
          {
            text: $t('create'),
            active: true,
          },
        ]"
      />
      <ts-loading-banner :loading="loading">
        <div class="row">
          <div class="col-md-4 tw-mb-5">
            <UserAccount v-model="model" :validate="errors" class="tw-h-full" />
          </div>
          <div class="col-md-8 tw-mb-5">
            <ts-panel>
              <ts-panel-wrapper>
                <Permission v-model="model" class="tw-h-full" />
              </ts-panel-wrapper>
            </ts-panel>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 tw-mb-5">
            <UserBranch v-model="model" :validate="errors" class="tw-h-56" />
          </div>
          <div class="col-md-4 tw-mb-5">
            <UserRole v-model="model" :validate="errors" class="tw-h-56" />
          </div>
          <div class="col-md-4 tw-mb-5">
            <AllowIp v-model="model" :validate="errors" class="tw-h-56" />
          </div>
        </div>
      </ts-loading-banner>
    </vue-custom-scrollbar>
    <div
      id="footer"
      class="app-footer m-0 tw-flex tw-justify-end tw-space-x-3 tw-bg-white"
    >
      <ts-button @click.prevent="$router.push({ name: 'user' })">{{
        $t("cancel")
      }}</ts-button>
      <ts-button
        color="primary"
        outline
        :waiting="waiting_new"
        @click.prevent="onSaveAddNew"
        >{{ $t("saveAddNew") }}</ts-button
      >
      <ts-button color="primary" :waiting="waiting" @click.prevent="onSave">{{
        $t("save")
      }}</ts-button>
    </div>
  </div>
</template>

<script>
import AppOptions from "@/config/AppOptions.vue";
import UserAccount from "./components/account.vue";
import UserRole from "./components/role.vue";
import UserBranch from "./components/branch.vue";
import AllowIp from "./components/allow-ip.vue";
import Permission from "./components/permision.vue";
import { mapActions } from "vuex";
import { Errors } from "form-backend-validation";

export default {
  name: "userCreate",
  components: {
    UserAccount,
    UserRole,
    Permission,
    UserBranch,
    AllowIp,
  },
  data() {
    return {
      loading: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      model: {
        user_id: 0,
        user_name: null,
        employee_id: null,
        email: null,
        roles: [],
        permissions: [],
        branches: [],
        allow_ip_address: [],
        disable: false,
        password: null,
        password_confirmation: null,
      },
    };
  },
  created() {
    AppOptions.appContentFullHeight = true;
    AppOptions.appContentClass = "p-0";
  },
  methods: {
    ...mapActions("auth/user", [
      "getUserRole",
      "getPermissions",
      "getEmployee",
      "getBranch",
    ]),
    async fetchResource() {
      this.loading = true;
      await this.getUserRole();
      await this.getPermissions();
      await this.getEmployee();
      await this.getBranch();
      this.loading = false;
    },
    onSaveAddNew() {
      this.errors = new Errors();
      this.waiting_new = true;
      this.$store
        .dispatch("auth/user/store", this.model)
        .then((response) => {
          this.$notify({ type: "success", text: response.message });
          this.clearInput();
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting_new = false;
        });
    },
    onSave() {
      this.errors = new Errors();
      this.waiting = true;
      this.$store
        .dispatch("auth/user/store", this.model)
        .then((response) => {
          this.$notify({ type: "success", text: response.message });
          this.clearInput();
          this.$router.push({ name: "user" });
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    clearInput() {
      (this.model.user_id = 0),
        (this.model.user_name = ""),
        (this.model.employee_id = null),
        (this.model.email = ""),
        (this.model.roles = null),
        (this.model.permissions = []),
        (this.model.branches = []),
        (this.model.allow_ip_address = []),
        (this.model.disable = false),
        (this.model.password = null),
        (this.model.password_confirmation = null);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchResource();
    });
  },
  beforeRouteLeave(to, from, next) {
    AppOptions.appContentFullHeight = false;
    AppOptions.appContentClass = "";
    next();
  },
};
</script>
